import {createUrl, getObjects} from "./api_common";

export const ENDPOINT_POST_OPTIONS= '/api/post_options'

export function getPostOptions(parameters = {}) {
    const defaultParameters = {
        //     isEdited: false,
    }
    let url = process.env.REACT_APP_API_URL + ENDPOINT_POST_OPTIONS
    url = createUrl(url, parameters, defaultParameters)
    return getObjects(url)
}